// import { AppContainer } from "react-hot-loader";
import React from "react";
import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { store, history } from "./storeInitializer";
import { Router, Route } from "react-router-dom";
import { getCookie, panelDefaultTitle } from "./config";
import * as Sentry from "@sentry/browser";
import { SWRConfig, useSWRConfig } from "swr";
import App from "./App";
import QboxmailApi from "@/qboxmailApi";
import { SwrContext } from "ReactContext/index";
// Styles
import "style-loader!css-loader!postcss-loader!../stylesheets/pikaday.css";
import "style-loader!css-loader!postcss-loader!../stylesheets/react-datepicker.css";

import "style-loader!css-loader!postcss-loader!../stylesheets/index.css";
import "style-loader!css-loader!postcss-loader!../stylesheets/fonts.css";
import "../stylesheets/app.scss";
import "tippy.js/dist/tippy.css";
import "normalize.css/normalize.css";
import "react-toastify/dist/ReactToastify.css";
import "pikaday/css/pikaday.css";
import "rc-slider/assets/index.css";
import "react-toggle/style.css";
import "react-circular-progressbar/dist/styles.css";

// set title of the page if customization is present
const title = getCookie("qb_customization_title") || panelDefaultTitle;
document.title = decodeURI(title);

// get url requested  by the user
const { pathname, search } = window.location;
const requestedURL = `${pathname}${search}`;
window.qb_requestedURL = requestedURL;

const api = new QboxmailApi({ useCookie: true });

// configure Sentry
if (process.env.NODE_ENV !== "development") {
  Sentry.init({ dsn: "https://24103e5ffd914dcf81131efd735794c4@sentry.io/1548893" });
}

const AppWrapper = () => {
  const { mutate } = useSWRConfig();

  return (
    <Provider store={store}>
      <SwrContext.Provider value={{ swrMutate: mutate }}>
        <Router history={history}>
          <Route
            path="/"
            render={(routeProps) => {
              return <App {...routeProps} />;
            }}
          />
        </Router>
      </SwrContext.Provider>
    </Provider>
  );
};

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <SWRConfig
    value={{
      fetcher: api.generateSWRFetcher(),
      revalidateOnFocus: false,
    }}
  >
    <AppWrapper />
  </SWRConfig>
);
